import React from "react";
import "./PageLoaderStyle.css";

const PageLoader = () => {
  return (
    <div className="preloader-wrapper">
      <div className="cssloader">
        <img src={"/assets/img/pageLoader.gif"} alt="" />
      </div>
    </div>
  );
};
export default PageLoader;